module.exports = "/_next/static/images/f868a26af471c6ae3fb05a170338c2ec-debit-card-cut-lg.png";